import { FC } from 'react';
import { LocalAccount } from '../../../types/LocalAccount';
import { getDateDiffFromNow } from '../../../../../utils/dates';
import { TwoLinesCell } from '@silverfort/sf-components';

type Props = LocalAccount;

const getExcludedTillLabel = (excludeTill: Date) => {
    const hoursLeft = getDateDiffFromNow(excludeTill, 'hours');

    if (hoursLeft === 0) {
        return 'Less than hour left';
    } else if (hoursLeft === 1) {
        return '1 Hour left';
    } else if (hoursLeft < 24) {
        return `${hoursLeft} Hours left`;
    }

    return `${getDateDiffFromNow(excludeTill, 'days')} Days left`;
};

const StatusCell: FC<Props> = ({ excludeTill, boundAdEntity }: Props) => {
    return (
        <TwoLinesCell
            topText={excludeTill ? 'Excluded' : (boundAdEntity ? 'Bound' : 'Unbound')}
            bottomText={excludeTill ? getExcludedTillLabel(excludeTill) : ''}
        />
    );
};

export default StatusCell;